import React from 'react';
import { withStyles } from '@material-ui/styles';

import CheckboxRow from '../../../partials/dataRows/CheckboxRow';
import styles, { customStyles } from '../styles/informationStep';
import flowRight from 'lodash.flowright';
import { connect } from 'react-redux';
import { isDefined } from '../../../utils/isDefined';

const AdditionalTab = ({ classes, fieldProps, licenses = {} }) => {
  return (
    <div className={classes.additionalGrid}>
      <div className={classes.additionalColumn}>
        <div className={classes.additionalBox}>
          <div className={classes.additionalBoxLabel}>Tablet</div>
          <CheckboxRow
            name="ipad_support"
            label="USER.ENABLE_IPAD"
            customStyles={customStyles.checkboxUser}
            {...fieldProps}
          />
        </div>
        <div className={classes.additionalBox}>
          <div className={classes.additionalBoxLabel}>Premium Supervision</div>
          <CheckboxRow
            name="premium_intrusion"
            label="USER.ENABLE_PREMIUM_SUPERVISION"
            customStyles={customStyles.checkboxUser}
            {...fieldProps}
          />
        </div>
        <div className={classes.additionalBox}>
          <div className={classes.additionalBoxLabel}>Premium Attendant</div>
          <CheckboxRow
            name="premium_attendant"
            label="USER.ENABLE_PREMIUM_ATTENDANT"
            customStyles={customStyles.checkboxUser}
            disabled={
              isDefined(licenses?.premiumAttendant) &&
              licenses?.premiumAttendant === false
            }
            {...fieldProps}
          />
        </div>
        <div className={classes.additionalBox}>
          <div className={classes.additionalBoxLabel}>Call control APIs</div>
          <CheckboxRow
            name="call_control_api"
            label="USER.ENABLE_CALL_CONTROL_API"
            customStyles={customStyles.checkboxUser}
            disabled={
              isDefined(licenses?.callControlApi) &&
              licenses?.callControlApi === false
            }
            {...fieldProps}
          />
          <CheckboxRow
            name="cloud_cti_api"
            label="USER.ENABLE_CLOUD_CTI_API"
            customStyles={customStyles.checkboxUser}
            disabled={
              isDefined(licenses?.cloudCtiApi) &&
              licenses?.cloudCtiApi === false
            }
            {...fieldProps}
          />
        </div>
        <div className={classes.additionalBox}>
          <div className={classes.additionalBoxLabel}>Line State API</div>
          <CheckboxRow
            name="line_state_api"
            label="USER.ENABLE_LINE_STATE_API"
            customStyles={customStyles.checkboxUser}
            disabled={
              isDefined(licenses?.lineStateApi) &&
              licenses?.lineStateApi === false
            }
            {...fieldProps}
          />
        </div>
        <div className={classes.additionalBox}>
          <div className={classes.additionalBoxLabel}>
            UC Analytics Integration
          </div>
          <CheckboxRow
            name="call_recording"
            label="USER.ENABLE_CALL_RECORDING"
            customStyles={customStyles.checkboxUser}
            disabled={
              isDefined(licenses?.callRecording) &&
              licenses?.callRecording === false
            }
            {...fieldProps}
          />
        </div>
      </div>
      <div className={classes.additionalColumn}>
        <div className={classes.additionalBox}>
          <div className={classes.additionalBoxLabel}>CRM Connect</div>
          <CheckboxRow
            name="crm_connect"
            label="USER.ENABLE_CRM_CONNECT"
            customStyles={customStyles.checkboxUser}
            disabled={
              isDefined(licenses?.crmConnect) && licenses?.crmConnect === false
            }
            {...fieldProps}
          />
        </div>
        <div className={classes.additionalBox}>
          <div className={classes.additionalBoxLabel}>Unified inbox</div>
          <CheckboxRow
            name="unified_inbox"
            label="USER.ENABLE_UNIFIED_INBOX"
            customStyles={customStyles.checkboxUser}
            {...fieldProps}
          />
        </div>
        <div className={classes.additionalBox}>
          <div className={classes.additionalBoxLabel}>
            3rd party CRM Connector
          </div>
          <CheckboxRow
            name="cloud_crm_connector"
            label="USER.3RD_PARTY_CRM_CONNECTOR"
            customStyles={customStyles.checkboxUser}
            disabled={
              isDefined(licenses?.thirdPartyCrmConnector) &&
              licenses?.thirdPartyCrmConnector === false
            }
            {...fieldProps}
          />
        </div>
        <div className={classes.additionalBox}>
          <div className={classes.additionalBoxLabel}>Chat</div>
          <CheckboxRow
            name="chat"
            label="USER.ENABLE_CHAT"
            customStyles={customStyles.checkboxUser}
            disabled={isDefined(licenses?.chat) && licenses?.chat === false}
            {...fieldProps}
          />
        </div>
        <div className={classes.additionalBox}>
          <div className={classes.additionalBoxLabel}>Teams</div>
          <CheckboxRow
            name="teams_application"
            label="USER.ENABLE_TEAMS_APPLICATION"
            customStyles={customStyles.checkboxUser}
            disabled={isDefined(licenses?.teams) && licenses?.teams === false}
            {...fieldProps}
          />
          <CheckboxRow
            name="teams_telephony"
            label="USER.ENABLE_TEAMS_TELEPHONY"
            customStyles={customStyles.checkboxUser}
            disabled={isDefined(licenses?.teams) && licenses?.teams === false}
            {...fieldProps}
          />
          <CheckboxRow
            name="teams_telephony_go"
            label="USER.ENABLE_TEAMS_TELEPHONY_APP"
            customStyles={customStyles.checkboxUser}
            disabled={isDefined(licenses?.teams) && licenses?.teams === false}
            {...fieldProps}
          />
        </div>
      </div>
    </div>
  );
};

const mapStatesToProps = ({ requestUserWizard }) => {
  return {
    licenses: requestUserWizard.selectOptions
      ? requestUserWizard.selectOptions.licenses
      : {}
  };
};

export default flowRight(
  connect(mapStatesToProps),
  withStyles(styles)
)(AdditionalTab);
